<div class="simple-dialog">
  <div mat-dialog-title class="dialog-header">
    <div class="dialog-title">
      <mat-icon>{{ icon }}</mat-icon>
      <h2>{{ title }}</h2>
    </div>
    <button mat-icon-button type="button" [attr.aria-label]="'common.buttons.close' | transloco" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <form [formGroup]="form">
      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'dataManagement.organizationSettings.fields.firstName' | transloco }}</mat-label>
          <input matInput formControlName="firstName" />
          <mat-error *ngIf="form.get('firstName')?.hasError('required')">
            {{ 'dataManagement.organizationSettings.validation.firstNameRequired' | transloco }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'dataManagement.organizationSettings.fields.lastName' | transloco }}</mat-label>
          <input matInput formControlName="lastName" />
          <mat-error *ngIf="form.get('lastName')?.hasError('required')">
            {{ 'dataManagement.organizationSettings.validation.lastNameRequired' | transloco }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'dataManagement.userData.columns.email' | transloco }}</mat-label>
          <input matInput formControlName="email" />
          <mat-error *ngIf="form.get('email')?.hasError('required')">
            {{ 'dataManagement.organizationSettings.validation.emailRequired' | transloco }}
          </mat-error>
          <mat-error *ngIf="form.get('email')?.hasError('email')">
            {{ 'dataManagement.organizationSettings.validation.emailInvalid' | transloco }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'dataManagement.organizationSettings.fields.phoneNumber' | transloco }}</mat-label>
          <input matInput formControlName="phoneNumber" />
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline" *ngIf="showFunction">
        <mat-label>{{ 'dataManagement.organizationSettings.fields.function' | transloco }}</mat-label>
        <input matInput formControlName="function" />
      </mat-form-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-button type="button" (click)="closeDialog()">
      {{ 'common.buttons.cancel' | transloco }}
    </button>
    <button mat-raised-button color="primary" type="button" (click)="doAction()">
      {{ (isEditMode ? 'common.buttons.save' : 'common.buttons.create') | transloco }}
    </button>
  </mat-dialog-actions>
</div>
